<template>
  <div>
    <v-dialog
      absolute
      transition="dialog-top-transition"
      max-width="600"
      v-model="dialog"
    >
      <template>
        <v-card>
          <v-toolbar color="primary" dark>Contact Us</v-toolbar>
          <v-card-text class="pt-6">
            <div ref="hubspotForm" id="hubspotForm" v-once></div>
          </v-card-text>
          <v-card-actions class="justify-end">
            <v-btn text @click="dialog = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>

    <v-row class="mt-4" justify="center" align="center">
      <v-col
        justify="center"
        align="center"
        class="mt-4"
        cols="12"
        height="800"
        style="position: relative; padding-top: 56.25%"
      >
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6929.311271337077!2d-95.42975361843519!3d29.729732846483195!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8640dcd05eea298b%3A0xc039a66102ab1cc6!2s35%2045%20Consulting-Houston!5e0!3m2!1sen!2seg!4v1647903364000!5m2!1sen!2seg"
          frameborder="0"
          allowfullscreen
          style="
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 60%;
            z-index: 1;
          "
        >
        </iframe>
        <v-row
          class="px-16"
          justify="center"
          align="center"
          no-gutters
          style="
            position: absolute !important;
            top: 40%;
            left: 4%;
            z-index: 2 !important;
          "
        >
          <v-col
            justify="center"
            align="center"
            cols="12"
            s="12"
            xs="12"
            lg="4"
            xl="4"
            md="12"
            v-for="(item, index) in items"
            :key="index"
          >
            <v-card class="text-center pa-8">
              <v-icon color="#a81e2d" v-text="item.icon"></v-icon>
              <v-card-title class="justify-center">
                {{ item.title }}
              </v-card-title>
              <v-card-text
                style="max-height: 50px !important; min-width: 300px"
                v-html="item.subtitle"
              ></v-card-text>
              <!-- href="https://app.hubspot.com/forms/5825854" -->
              <v-card-text
                class="pt-8"
                v-on="
                  item.action == 'SEND A MESSAGE'
                    ? { click: openContactForm }
                    : {}
                "
              >
                <a
                  :href="
                    item.action == 'OPEN A TICKET'
                      ? 'Mailto: incident@3545consulting.com'
                      : null"
                  style="color: #a81e2d !important; text-decoration: none"
                  >{{ item.action }}
                </a></v-card-text
              >
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  methods: {
    openContactForm() {
      this.dialog = true;
      if (!this.$refs.hubspotForm || this.$refs.hubspotForm.innerHTML === "") {
        const script = document.createElement("script");
        script.src = "https://js.hsforms.net/forms/v2.js";
        document.body.appendChild(script);
        script.addEventListener("load", () => {
          if (window.hbspt) {
            window.hbspt.forms.create({
              portalId: "5825854",
              formId: "a265c4b5-4606-4254-8594-3c5820f08fcf",
              target: "#hubspotForm",
            });
          }
        });
      }
    },
  },
  mounted() {},
  data() {
    return {
      dialog: false,
      items: [
        {
          icon: "mdi-map-marker",
          title: "Our Address",
          subtitle: "3120 Southwest Freeway, Suite 530Houston, TX 77098",
          action: "DIRECTIONS",
        },
        {
          icon: "mdi-email",
          title: "Contact Info",
          subtitle: "Email : info@3545consulting.com <br/> Phone: 713-789-3323",
          action: "SEND A MESSAGE",
        },
        {
          icon: "mdi-account-multiple ",
          title: "Our Support",
          subtitle:
            "Main Support : incident@3545consulting.com <br/> Phone: 713-789-3323",
          action: "OPEN A TICKET",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
</style>